import React, { useState, useEffect } from "react";
import api from "../lib/api";

const CurrencySelect = ({ value, onChange, testid = "currency-select" }) => {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/currencies").then((r) => setList(r.data.currencies || [])).catch(() => {}); }, []);
  return (
    <select className="cur-select" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid} aria-label="Currency">
      {list.length === 0 && <option value="USD">USD ($)</option>}
      {list.map((c) => (<option key={c.code} value={c.code}>{`${c.code} (${c.symbol})`}</option>))}
    </select>
  );
};

export default CurrencySelect;
